
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.734 17.003c-.04-4.053 3.305-5.996 3.454-6.093-1.88-2.751-4.808-3.127-5.851-3.171-2.492-.252-4.862 1.467-6.127 1.467-1.261 0-3.213-1.43-5.28-1.392-2.716.04-5.221 1.579-6.619 4.012-2.822 4.897-.723 12.151 2.028 16.123 1.344 1.944 2.947 4.127 5.051 4.049 2.026-.081 2.793-1.311 5.242-1.311s3.138 1.311 5.283 1.271c2.18-.041 3.562-1.981 4.897-3.931 1.543-2.255 2.179-4.439 2.216-4.551-.048-.022-4.252-1.632-4.294-6.473zM20.705 5.11C21.822 3.755 22.576 1.875 22.37 0c-1.609.066-3.559 1.072-4.713 2.423-1.036 1.199-1.942 3.113-1.699 4.951 1.796.14 3.629-.913 4.747-2.264z"}})])
          )
        }
      }
    